<template>
  <GeneralForm :jenisJurnal="3" :title="title" :routeBack="routeBack" :jurnalUrl="url" />
</template>

<script>
import GeneralForm from '@/views/jurnal/GeneralForm.vue';

export default {
    components: {
        GeneralForm
    },
    data:() => ({
       title : 'Jurnal Penerimaan Kas',
       url : '/api/ju',
       routeBack : 'jpklist',
    }),
    methods: {
       
    }
}
</script>


<style>

</style>